import Icon from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { generateSavedViewUrl } from "components/saved_searches/utils";
import Button from "components/ui/button/Button";
import { BasicView } from "components/views/SavedViewsMenu";
import { EllipsisTooltipText } from "lib/core_components/EllipsisTooltip";
import { useUnpinView } from "lib/hooks/api/notices/views/useUnpinView";
import { useDeletePinnedView } from "lib/hooks/api/pinned_views/useDeletePinnedView";
import HolderIcon from "lib/icons/Holder";
import { assert } from "lib/utils";

import css from "./PinnedViewItemMini.module.scss";

type PinnedViewItemProps = {
  view: BasicView;
  setSelectedView: (viewId?: string, viewName?: string, context?: string) => void;
};

function PinnedViewItem({ view, setSelectedView }: PinnedViewItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: view.id || "",
  });

  const dataType = view.dataType;

  const { mutate: unpinViewMutation, isLoading } = useUnpinView();
  const { mutate: unpinView, isLoading: isUnpinViewLoading } = useDeletePinnedView();

  return (
    <a
      key={view.id}
      className={css.savedViewItem}
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      {...attributes}
      {...listeners}
      aria-label="pinned view"
      onClick={(event) => {
        event.preventDefault();
        setSelectedView(view.id, view.name, "Pinned view list");
      }}
      href={generateSavedViewUrl(view.id, view.dataType)}
      rel="noopener noreferrer"
    >
      <div className={css.holderContainer}>
        <Icon
          aria-label="drag target"
          component={HolderIcon}
          className={css.holderIcon}
          key={view.name}
        />
      </div>
      <EllipsisTooltipText fullText={view.name} containerClassname={css.paneViewTitle} />
      {/* The button is here to unpin the view */}
      <Button
        as="button"
        icon="pin02Filled"
        className={css.pinnedIcon}
        aria-label="toggle pinned view"
        buttonType="tertiary"
        buttonStyle="inverse"
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          assert(view.id);
          if (dataType === "notice") {
            unpinViewMutation({ id: view.id, name: view.name });
          } else {
            unpinView({ input: { savedViewId: view.id } });
          }
        }}
        loading={isLoading || isUnpinViewLoading}
      />
    </a>
  );
}

export default PinnedViewItem;
